import { render } from "./TheFormGroupAnamnesis.vue?vue&type=template&id=f57a67d0&ts=true"
import script from "./TheFormGroupAnamnesis.vue?vue&type=script&lang=ts"
export * from "./TheFormGroupAnamnesis.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__